import React from 'react';
import "./navbar.css";

export const Navbar = () => {
    return (
        <div className='navbar'>
            {/* You can add any content you want to display in the navbar */}
            {/* For example, a title or logo */}

        </div>
    );
};
